import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

//Components
import BTicketAccessInfoLoungesFasttrack from './b-ticket-access-info-lounges-fasttrack/b-ticket-access-info-lounges-fasttrack.vue';
import BTicketAccessInfoParking from './b-ticket-access-info-parking/b-ticket-access-info-parking.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-access-info',
  props: {
  //prop to choose which child to render
  type: {
    type: String,
    required: true,
    validator: (value: string) => ['loungesFasttrack', 'parking'].includes(value),
  },

  //shared prop
  accessInfo: {
    type: [Object, String],
    required: true,
  },

  //props used only by the lounges-fasttrack child
  accessInfoFromEntranceInfo: {
    type: Boolean,
    default: false,
  },
  subItems: {
    type: Array,
    default: () => [],
  },
  hideViewTicketsButton: {
    type: Boolean,
    default: false,
  },
  showProviderLogo: {
    type: Boolean,
    default: false,
  },
  product: {
    type: Object,
    default: () => ({}),
  },

  //props used only by the parking child
  // eslint-disable-next-line vue/require-default-prop
  accessInfoNumber: {
    type: Number,
    required: false,
  },
  licensePlate: {
    type: String,
    default: '',
  },
},
  setup(__props, { expose }) {

const props = __props;




//select  child component - based on type prop
const childComponent = computed(() => {
 return props.type === 'loungesFasttrack'
    ? BTicketAccessInfoLoungesFasttrack
    : BTicketAccessInfoParking;
});

const { type, ...restProps } = props;
let childProps = restProps;
if (props.type !== 'parking') {
  const { accessInfoNumber, licensePlate, ...filteredProps } = childProps;
  childProps = filteredProps;
};

expose({
  childComponent,
  childProps,
});

return { __sfc: true,props, childComponent, type, restProps, childProps }
}

})